kv.controller('expenseVatTypeEditCtrl', function ($uibModalInstance, data, $injector, $scope) {
	return new dictionaryEditCtrl($uibModalInstance, data, $injector, $scope, {
		entity: "expense_vat_type",
		primaryKey: "vat_type_id",
		newEntity:{
		},
		prepareDataToSave: function () {
			let dataToSend = angular.copy(this.data);
			return dataToSend;
		}
	});
});